/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './other-vitals.reducer';

export const OtherVitalsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const otherVitalsEntity = useAppSelector(state => state.otherVitals.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="otherVitalsDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.otherVitals.detail.title">OtherVitals</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.otherVitals.id">Id</Translate>
            </span>
          </dt>
          <dd>{otherVitalsEntity.id}</dd>
          <dt>
            <span id="respiratoryRate">
              <Translate contentKey="tinyMedicRestApp.otherVitals.respiratoryRate">Respiratory Rate</Translate>
            </span>
          </dt>
          <dd>{otherVitalsEntity.respiratoryRate}</dd>
          <dt>
            <span id="bodyTemp">
              <Translate contentKey="tinyMedicRestApp.otherVitals.bodyTemp">Body Temp</Translate>
            </span>
          </dt>
          <dd>{otherVitalsEntity.bodyTemp}</dd>
          <dt>
            <span id="bodySurfaceArea">
              <Translate contentKey="tinyMedicRestApp.otherVitals.bodySurfaceArea">Body Surface Area</Translate>
            </span>
          </dt>
          <dd>{otherVitalsEntity.bodySurfaceArea}</dd>
          <dt>
            <span id="painScore">
              <Translate contentKey="tinyMedicRestApp.otherVitals.painScore">Pain Score</Translate>
            </span>
          </dt>
          <dd>{otherVitalsEntity.painScore}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.otherVitals.active">Active</Translate>
            </span>
          </dt>
          <dd>{otherVitalsEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.otherVitals.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{otherVitalsEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.otherVitals.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{otherVitalsEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.otherVitals.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{otherVitalsEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.otherVitals.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{otherVitalsEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.otherVitals.glucoUser">Gluco User</Translate>
          </dt>
          <dd>{otherVitalsEntity.glucoUser ? otherVitalsEntity.glucoUser.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/other-vitals" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/other-vitals/${otherVitalsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default OtherVitalsDetail;
